import { getElementById, reloadWindow } from "../services/dom";
import navbarTemplate from "../templates/sections/navbar.html?raw";
const sync_motion = "/img/sync_motion.gif";
const cloud_saved = "/img/cloud_saved.svg";
const cloud_save_error = "/img/cloud_save_error.svg";
const sync_static = "/img/sync_static.svg";
import { PlanTemplateDb } from "../services/indexeddb/planTemplateDb";
import { clearAllDatabases } from "../services/indexeddb/clearDatabases";
import { getApi } from "../services/api";
import { getStringFromLocalStorage } from "../services/localStorage";
import { RecipeStore } from "../services/stores/recipeStore";
import { UnitStore } from "../services/stores/unitStore";
import { PlanStore } from "../services/stores/planStore";
import { InventoryStore } from "../services/stores/inventoryStore";
// import { ShoppingListStore } from "../services/stores/shoppingListStore";

const apiUrl = import.meta.env.VITE_API_URL as string;
const apiToken = getStringFromLocalStorage("idToken");

export default class NavBar extends HTMLElement {
  private recipeStore = RecipeStore.getInstance();
  private unitStore = UnitStore.getInstance();
  private planStore = PlanStore.getInstance();
  private inventoryStore = InventoryStore.getInstance();
  // private shoppingListStore = ShoppingListStore.getInstance();
  private planTemplateDb = new PlanTemplateDb();
  constructor() {
    super();

    const navbarLinks = [
      {
        name: "Plan",
        href: "/plan",
      },
      {
        name: "Templates",
        href: "/plantemplate",
      },
      {
        name: "Shopping List",
        href: "/shoppinglist",
      },
      {
        name: "Pantry",
        href: "/pantry",
      },
      {
        name: "Recipe",
        href: "/recipe",
      },
    ];

    const container = getElementById("section-navbar");
    container.classList.add("mx-auto", "px-2");
    container.innerHTML = navbarTemplate;

    // Set up Web MenuBlock
    const webMenuBlock = getElementById("webMenu");
    navbarLinks.forEach((link) => {
      const linkOuter = document.createElement("div");
      linkOuter.classList.add("text-gray-300", "hover:bg-gray-700", "hover:text-white", "block", "px-3", "py-1", "rounded-md", "text-base", "font-medium");
      const linkInner = document.createElement("button");
      linkInner.addEventListener("click", (event) => {
        event.preventDefault();
        (window as any).appRouter.navigate(link.href);
      });
      linkInner.textContent = link.name;
      linkOuter.appendChild(linkInner);
      webMenuBlock.appendChild(linkOuter);
    });

    // Set up Mobile MenuBlock
    const mobileMenuBlock = getElementById("mobileMenu");
    navbarLinks.forEach((link) => {
      const linkOuter = document.createElement("div");
      linkOuter.classList.add("text-gray-300", "hover:bg-gray-700", "hover:text-white", "block", "px-3", "rounded-md", "text-base", "font-medium");
      const linkInner = document.createElement("a");
      linkInner.addEventListener("click", (event) => {
        event.preventDefault();
        (window as any).appRouter.navigate(link.href);
      });
      linkInner.textContent = link.name;
      linkOuter.appendChild(linkInner);
      mobileMenuBlock.appendChild(linkOuter);
    });

    // Set up Mobile Menu Toggle
    const button = getElementById("mobile-menu-toggle");
    const mobileMenuIconClosed = container.querySelector("#mobile-menu-icon-closed");
    const mobileMenuIconOpen = container.querySelector("#mobile-menu-icon-open");
    const mobileMenu = container.querySelector("#mobile-menu");
    button.addEventListener("click", () => {
      mobileMenuIconClosed?.classList.toggle("hidden");
      mobileMenuIconClosed?.classList.toggle("block");
      mobileMenuIconOpen?.classList.toggle("hidden");
      mobileMenuIconOpen?.classList.toggle("block");
      mobileMenu?.classList.toggle("hidden");
    });

    // Set up UserMenu
    const userMenuButton = getElementById("userMenuButton");
    const userMenu = getElementById("userMenu");
    userMenuButton.addEventListener("click", () => {
      userMenu.classList.toggle("hidden");
    });

    // Set up Sync Button Listener
    const syncButton = getElementById("cloudSync");
    syncButton.addEventListener("click", async () => {
      await this.syncData();
      setTimeout(async () => {
        await this.reloadPWA();
        }, 2000);
    });

    // Set up Logout Button Listener
    const logoutButton = getElementById("logoutButton");
    logoutButton.addEventListener("click", async () => {
      const confirmLogout = confirm("Are you sure you want to log out?");
      if (confirmLogout) {
        // Clear local storage and IndexedDB databases
        localStorage.clear();
        await clearAllDatabases();
        reloadWindow();
      }
    });

    // Set up the Profile Button Listener
    const profileButton = getElementById("profileButton");
    profileButton.addEventListener("click", () => {
      (window as any).appRouter.navigate("/profile");
    });

    // Set up the Home Button Listener
    const logoButton = getElementById("navbarLogo");
    logoButton.addEventListener("click", () => {
      (window as any).appRouter.navigate("/");
    });
  }

  private async syncData(): Promise<void> {
    console.log("syncing data");
    (document.getElementById("sync_img") as HTMLImageElement).src = sync_motion;

    // do the sync
    try {
      await Promise.all([
        this.recipeStore.getHouseholdRecipes(true),
        this.unitStore.getUnits(true),
        this.planStore.getPlans(true),
        this.inventoryStore.getInventory(true),
        // this.shoppingListStore.getShoppingList("TBC", "TBC", true),
        this.getPlanTemplates(),
      ]);

      // update src tag of sync button to temporarily show cloud saved image
      (document.getElementById("sync_img") as HTMLImageElement).src = cloud_saved;

      setTimeout(() => {
        // update src tag of sync button to show static sync image
        (document.getElementById("sync_img") as HTMLImageElement).src = sync_static;
      }, 2000);
    } catch (error: any) {
      setTimeout(() => {
        (document.getElementById("sync_img") as HTMLImageElement).src = cloud_save_error;

        // update src tag of sync button to show static sync image
        (document.getElementById("sync_img") as HTMLImageElement).src = sync_static;
      }, 2000);
      console.log("error syncing data");
      console.log(error);
    }
  }

  private async getPlanTemplates(): Promise<void> {
    try {
      const planTemplateItems = await getApi(apiUrl, "mealplantemplate", apiToken);
      this.planTemplateDb.addPlanTemplates(planTemplateItems, true);
    } catch (e: any) {
      console.log(e);
    }
  }

  public async reloadPWA(): Promise<boolean> {
    try {
      // Check if service workers are supported
      if ('serviceWorker' in navigator) {
        // Get all service worker registrations
        const registrations = await navigator.serviceWorker.getRegistrations();

        // Unregister all service workers
        const unregisterPromises = registrations.map(registration => registration.unregister());
        await Promise.all(unregisterPromises);

        // Clear the cache
        if ('caches' in window) {
          const cacheKeys = await caches.keys();
          const deleteCachePromises = cacheKeys.map(key => caches.delete(key));
          await Promise.all(deleteCachePromises);
        }

        // Reload the page to trigger registration of the latest service worker
        window.location.reload();
        return true;
      } else {
        console.warn('Service workers are not supported in this browser');
        return false;
      }
    } catch (error) {
      console.error('Failed to update PWA:', error);
      return false;
    }
  }
}

customElements.define("nav-bar", NavBar);
